import BlockHeader from "component/BlockHeader/BlockHeader";
import React, { useContext, useEffect, useState } from "react";
import { connect } from "react-redux";
import stateMap from "store/stateMap";
import { UserContext } from "..";
import api from "api";
import ComponentExperience from "component/Experience";
import { Waypoint } from "react-waypoint";

import { InitiativeSlider } from 'component/InitiativeList';
import { TalentPoolSlider } from "component/TalentPool";
import { PageCredential } from "component/PageCredential";

const PageProfileUserBio = connect(stateMap)((props) => {
    const currentUserContext = useContext(UserContext);
    const [experiences, setExperiences] = useState(false);
    
    const [waypointPool, setWaypointPool] = useState(false);
    const [waypointLatest, setWaypointLatest] = useState(false);

    useEffect(() => {
        if(!props.auth.user)
        {
            return;
        }

        if(!currentUserContext.profile)
        {
            return;
        }

        api('/Profile/Experience', 'get', {
            user_id : currentUserContext.profile.UserID
            ,include_likes : true
        }, 'Bearer ' + props.auth.token)
            .then(response => {
                setExperiences(response.experience);
            })
        
    }, [props.auth.user])

    return (
        <div className="profile-user-bio">
            <PageCredential title={`${currentUserContext.profile.UserDisplayName}`}/>
            <div className="container">
                <div className="w-800 mx-auto relative">
                    <BlockHeader title="Experiences"/>
                    <ul className="experiences-list">
                        {
                            experiences !== false && experiences.map(experience => (
                                <li className="experience" key={experience.ExpID}>
                                    <ComponentExperience experience={experience}/>
                                </li>
                            ))
                        }
                        {
                            experiences === false &&
                            <li className="experience" key="experience-skeleton">
                                <div className="wrapper">
                                    <span className="skeleton"></span>
                                </div>
                            </li>
                        }
                    </ul>
                </div>
            </div>
            {
                experiences && 
                <div style={{backgroundColor : '#c9c9c9'}}>
                    <div className="container">
                        <div>
                            <Waypoint onEnter={() => {
                                setWaypointLatest(true);
                            }}/>
                            <div className="mt-5">
                                <BlockHeader 
                                    title="Latest Initiative" 
                                    desc="Discover the various exciting initiatives that are being and have been built through Crowdbees."
                                    link={{
                                        pathname : '/initiative'
                                    }} />
                                {
                                    waypointLatest && 
                                    <InitiativeSlider initiatives_args={{
                                        paged               : 1
                                        ,posts_per_page     : 10
                                    }} />
                                }
                            </div>
                        </div>
                        <div className="mt-5">
                            <Waypoint onEnter={() => {
                                setWaypointPool(true);
                            }}/>
                            <BlockHeader title="Meet The Talent" desc="Meet various talents to work together" link={{
                                pathname : "/talent-pool"
                            }}/>
                            {
                                waypointPool && 
                                <TalentPoolSlider list_args={{
                                    posts_per_page : 4
                                    ,include_user_score : 1
                                    ,include_bio : 1
                                    ,sortby         : 'ActivationDate'
                                    ,sort           : 'DESC'
                                }}/>
                            }
                        </div>
                    </div>
                </div>
            }
        </div>
    )
});

export default PageProfileUserBio;